import request from '@/utils/request'

export function token(data) {
  return request({
    url: '/api/account/token',
    method: 'post',
    isAnonymous: true,
    data
  })
}

export function refreshToken(data) {
  return request({
    url: '/api/account/refreshtoken',
    method: 'post',
    isAnonymous: true,
    data
  })
}

export function getInfo() {
  return request({
    url: '/api/account/getinfo',
    method: 'get'
  })
}

// 从mock获取路由, 开发时路由写在mock中 , 通过
export function getMockMenus() {
  return request({
    url: '/vue-element-admin/menu',
    method: 'get',
    isAnonymous: true
  })
}

// 注册
export function register(params) {
  return request({
    url: '/Mart/MartAccount/Register',
    method: 'POST',
    data: params
  })
}

// 获取用户信息
export function getUserInfo(params) {
  return request({
    url: '/Mart/MartAccount/GetUserInfo',
    method: 'GET',
    params
  })
}

// 发送注册短信
export function sendRegisterSMS(params) {
  return request({
    url: '/Mart/MartAccount/sendRegisterSMS',
    method: 'POST',
    data: params
  })
}

// 手机+验证码 登陆
export function loginBySMSPhoneCode(params) {
  return request({
    url: '/Mart/MartAccount/loginBySMSPhoneCode',
    method: 'POST',
    data: params
  })
}

// 登录发送验证码
export function sendLoginCode(params) {
  return request({
    url: '/Mart/MartAccount/SendLoginCode',
    method: 'POST',
    data: params
  })
}

// 手机号/帐号 密码登陆
export function login(params) {
  return request({
    url: '/Mart/MartAccount/Login',
    method: 'POST',
    data: params
  })
}
